import { restoreButtonPendingState, setButtonPendingState } from '../helpers.js';
function initLogoutAction() {
    $(document).on('click', '[data-logout-route], [data-logout-callback]', function (event) {
        const $trigger = $(this);
        if ($trigger.prop('disabled')) {
            event.preventDefault();
            return;
        }

        if (typeof setButtonPendingState !== 'function') {
            throw new Error('setButtonPendingState is required but was not found');
        }

        const logoutPendingLabel = String($trigger.data('logout-pending-label') || 'Logging out...').trim();
        const snapshot = setButtonPendingState($trigger, logoutPendingLabel);

        if (snapshot === null) {
            $trigger.prop('disabled', true);
        }

        const route = String($trigger.data('logout-route') || '').trim();
        if (route !== '') {
            event.preventDefault();
            window.location.assign(route);
            return;
        }

        const callbackName = String($trigger.data('logout-callback') || '').trim();
        const callbackFn = callbackName !== '' ? window[callbackName] : null;
        if (typeof callbackFn === 'function') {
            event.preventDefault();
            callbackFn();
            return;
        }

        if (typeof restoreButtonPendingState !== 'function') {
            throw new Error('restoreButtonPendingState is required but was not found');
        }
        restoreButtonPendingState($trigger, snapshot);
    });
}

initLogoutAction();
